import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">分类浏览</h2>
          <p className="text-sm text-foreground-500 mt-1.5">海量内容，按分类快速找到你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.link}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[4/3] rounded-xl overflow-hidden mb-3">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`${cat.name} - 茄子视频高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-white text-sm md:text-base`}></i>
                  </div>
                  <div>
                    <span className="text-sm md:text-base font-semibold text-white block leading-tight">{cat.name}</span>
                    <span className="text-[10px] md:text-xs text-white/70">{cat.count}部</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}